import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 verify_tenant_user_profile: { message: "idle" },
};

export const verify_tenant_user_profile_Slice = createSlice({
 name: "verify_tenant_user_profile",
 initialState,
 reducers: {
  success_verify_tenant_user_profile: (state, action) => {
   state.verify_tenant_user_profile = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_verify_tenant_user_profile: (state, action) => {
   state.verify_tenant_user_profile = { status: app_consts.FAIL, message: action.payload };
  },
  reset_verify_tenant_user_profile: (state) => {
   state.verify_tenant_user_profile = { status: app_consts.IDLE };
  },
  loading_verify_tenant_user_profile: (state) => {
   state.verify_tenant_user_profile = { status: app_consts.LOADING };
  },
 }
});

export const { success_verify_tenant_user_profile, fail_verify_tenant_user_profile, reset_verify_tenant_user_profile, loading_verify_tenant_user_profile } = verify_tenant_user_profile_Slice.actions;

export default verify_tenant_user_profile_Slice.reducer;